import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodePlaceholderMappingRow — Two-column row: incoming placeholder -> output placeholder.
 * Used by: Trigger from WF, Email Trigger.
 */

const Root = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  width: '100%',
});

const Column = styled('div')({
  flex: 1,
  minWidth: 0,
});

const ColumnLabel = styled(Typography)(({ theme }) => ({
  fontSize: NODE_UI.fontSize.caption,
  fontWeight: NODE_UI.fontWeight.label,
  color: theme.palette.text.secondary,
  marginBottom: 2,
  userSelect: 'none',
}));

const ArrowContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  flexShrink: 0,
  paddingTop: 16, // align with fields when labels shown
}));

const DeleteButton = styled(IconButton)(({ theme }) => ({
  padding: '4px',
  paddingTop: 20,
  color: theme.palette.text.secondary,
  flexShrink: 0,
  '&:hover': { color: theme.palette.error.main },
}));

const NodePlaceholderMappingRow = React.memo(function NodePlaceholderMappingRow({
  incomingLabel = 'Incoming',
  outgoingLabel = 'Maps To',
  renderIncoming,
  renderOutgoing,
  incomingValue,
  outgoingValue,
  onIncomingChange,
  onOutgoingChange,
  onDelete,
  showLabels = true,
  sx,
}) {
  return (
    <Root onMouseDown={stopPropagation} onClick={stopPropagation} onPointerDown={stopPropagation} sx={sx}>
      <Column>
        {showLabels && <ColumnLabel>{incomingLabel}</ColumnLabel>}
        {renderIncoming
          ? renderIncoming({ value: incomingValue, onChange: onIncomingChange })
          : null
        }
      </Column>
      <ArrowContainer>
        <ArrowForwardIcon sx={{ fontSize: 16 }} />
      </ArrowContainer>
      <Column>
        {showLabels && <ColumnLabel>{outgoingLabel}</ColumnLabel>}
        {renderOutgoing
          ? renderOutgoing({ value: outgoingValue, onChange: onOutgoingChange })
          : null
        }
      </Column>
      {onDelete && (
        <DeleteButton size="small" onClick={(e) => { stopPropagation(e); onDelete(); }}>
          <DeleteOutlineIcon sx={{ fontSize: 16 }} />
        </DeleteButton>
      )}
    </Root>
  );
});

export default NodePlaceholderMappingRow;
